export default __webpack_public_path__ + "static/media/Sushree Mahapatra, Member, NIBA Alumni Association.3a645a43.jpg";